<template>
  <b-container fluid="">
    <!-- <b-row>
      <b-col md="3" sm="6">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>待处理入款</h6>
            </div>
            <div class="iq-customer-box d-flex align-items-center justify-content-between mt-3">
              <div class="d-flex align-items-center">
                <h2>352</h2>
              </div>
              <div class="iq-map text-primary font-size-32"><i class="ri-bar-chart-grouped-line"></i></div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col md="3" sm="6">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>待处理出款</h6>
            </div>
            <div class="iq-customer-box d-flex align-items-center justify-content-between mt-3">
              <div class="d-flex align-items-center">
                <h2>37</h2>
              </div>
              <div class="iq-map text-danger font-size-32"><i class="ri-bar-chart-grouped-line"></i></div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col md="3" sm="6">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>总入款订单</h6>
            </div>
            <div class="iq-customer-box d-flex align-items-center justify-content-between mt-3">
              <div class="d-flex align-items-center">
                <h2>32</h2>
              </div>
              <div class="iq-map text-warning font-size-32"><i class="ri-bar-chart-grouped-line"></i></div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col md="3" sm="6">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>总出款订单</h6>
            </div>
            <div class="iq-customer-box d-flex align-items-center justify-content-between mt-3">
              <div class="d-flex align-items-center">
                <h2>27</h2>
              </div>
              <div class="iq-map text-info font-size-32"><i class="ri-bar-chart-grouped-line"></i></div>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row> -->
    <div>
      <iq-card>
        <template v-slot:body>
          <h4 style="color: #837BEC; font-weight: 800;">条件查询</h4>
          <div style="margin-top: 20px;">
            <b-form ref="form" @submit="handleAddSubmit">
              <!-- 1 -->
              <!-- {{ USER }} -->
              <b-form-group label="所属商家" label-for="name-input" v-if="USER.role === 0 || USER.role === 1">
                <b-form-select v-model="searchForm.shop_id" :options="shops" class="mt-3" text-field="label"
                  value="value"></b-form-select>
              </b-form-group>
              <b-form-group label="订单状态" label-for="name-input" style="margin-top: 30px;">
                <b-form-radio-group id="radio-group-2" v-model="searchForm.status" name="radio-sub-component">
                  <b-form-radio :value="100">全部</b-form-radio>
                  <b-form-radio :value="0">待确认</b-form-radio>
                  <b-form-radio :value="1">成功</b-form-radio>
                  <b-form-radio :value="2">驳回</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group label="日期范围" label-for="name-input" style="width: 600px; margin-top: 30px;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div>
                    开始日期
                  </div>
                  <div>
                    <b-form-datepicker id="example-datepicker1" v-model="searchForm.start" class="mb-2"
                      style="display: flex; align-items: center;"></b-form-datepicker>
                  </div>
                  <div>
                    结束日期
                  </div>
                  <div>
                    <b-form-datepicker id="example-datepicker2" v-model="searchForm.end" class="mb-2"
                      style="display: flex; align-items: center;"></b-form-datepicker>
                  </div>
                </div>
              </b-form-group>
              <div style="display: flex; justify-content: flex-end;">
                <b-button type="submit" variant="primary" size="lg">查询总额</b-button>
              </div>
            </b-form>
          </div>
        </template>
      </iq-card>
    </div>
  </b-container>
</template>
<script>
import { core } from '../../config/pluginInit'
import axiosInstance from '../../services/index'
export default {
  name: 'Dashboard1',
  mounted() {
    core.index()

    this.getShops()
  },
  data() {
    return {
      USER: JSON.parse(localStorage.getItem('USER')),
      searchForm: {
        shop_id: '',
        daterange: '',
        status: 100,
        start: '',
        end: ''
      },
      shops: []
    }
  },
  methods: {
    getShops() {
      axiosInstance.get(`/shop/options`).then((res) => {
        this.shops = res.data.items
      })
    },
    handleAddSubmit() {
      let url = `/order/sum?status=${this.searchForm.status}&shop_id=${this.searchForm.shop_id}`

      if (this.searchForm.start && this.searchForm.end) {
        url += `&daterange=${this.dateToTimestamp(this.searchForm.start)},${this.dateToTimestamp(this.searchForm.end)}`
      }
      axiosInstance.get(url, {}).then((res) => {
        alert(`当前共计${res.data.tp}`)
      }).catch(() => {
        // console.error('创建失败:', error)
      })

       // 阻止默认的表单提交行为
       event.preventDefault()
    },
    dateToTimestamp(dateString) {
      // 创建一个 Date 对象
      const date = new Date(dateString)
      // 获取时间戳（单位为毫秒）
      const timestamp = date.getTime()
      return timestamp / 1000
    },
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
</style>
